export default "__VITE_ASSET__B7u_Zfqw__"